import React, { useEffect, useState } from "react";
import "./UpdateProfile.css";
import { useGlobalContext } from "../../../context/context";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FiArrowLeft, FiCheck, FiLoader } from "react-icons/fi";

function UpdateProfile({ setTab }) {
  const accessToken = (() => {
    try { return JSON.parse(sessionStorage.getItem("accessToken")); } catch { return null; }
  })();
  const { userDetails, getUser, baseUrl, setUserDetails } = useGlobalContext();
  const details = userDetails && !Array.isArray(userDetails) ? userDetails : {};
  const countryName = typeof details.country === "string" ? details.country : details.country?.name;
  const { handleSubmit, register, reset } = useForm({
    defaultValues: {
      firstName: details.firstName || "",
      lastName: details.lastName || "",
      gender: details.gender || "",
      dob: details.dob || "",
      maritalStatus: details.maritalStatus || details.maritalstatus || "",
      city: details.city || "",
      country: countryName || "",
      address: details.address || "",
    },
  });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    reset({
      firstName: details.firstName || "",
      lastName: details.lastName || "",
      gender: details.gender || "",
      dob: details.dob || "",
      maritalStatus: details.maritalStatus || details.maritalstatus || "",
      city: details.city || "",
      country: countryName || "",
      address: details.address || "",
    });
  }, [details.firstName, details.lastName, details.gender, details.dob, details.maritalStatus, details.maritalstatus, details.city, countryName, details.address, reset]);

  const handleUpdate = async (values) => {
    if (!details._id) {
      setSaveError("Your account could not be identified. Refresh your profile and try again.");
      return;
    }
    setLoading(true);
    setFeedback("");
    setSaveError("");
    const payload = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      gender: values.gender,
      dob: values.dob,
      maritalStatus: values.maritalStatus,
      city: values.city.trim(),
      country: values.country.trim(),
      address: values.address.trim(),
      email: details.email || "",
      phone: details.phone || "",
    };
    try {
      const response = await axios.put(`${baseUrl}users/${details._id}`, payload, {
        headers: { token: accessToken },
      });
      if (response.status !== 200) throw new Error("Your profile could not be saved.");
      const refreshed = await getUser(accessToken, details._id);
      if (!refreshed) {
        const savedUser = {
          ...details,
          ...payload,
          country: details.country && typeof details.country === "object"
            ? { ...details.country, name: payload.country }
            : payload.country,
          maritalstatus: payload.maritalStatus,
        };
        setUserDetails(savedUser);
        sessionStorage.setItem("user", JSON.stringify(savedUser));
      }
      setFeedback("Your details have been updated.");
      setTab(1);
    } catch {
      setSaveError("We couldn't save these details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="update_profile pg-update-profile">
      <header className="pg-panel-heading">
        <div><span className="pg-kicker">PERSONAL INFORMATION</span><h2>Update details</h2><p>Changes are saved to your ProfitGrowing account.</p></div>
        <button type="button" className="pg-panel-edit pg-back-button" onClick={() => setTab(1)}><FiArrowLeft size={15} /> Back to profile</button>
      </header>
      {feedback && <p className="pg-form-success" role="status"><FiCheck size={15} />{feedback}</p>}
      {saveError && <p className="pg-form-error" role="alert">{saveError}</p>}
      <form className="update_form pg-update-form" onSubmit={handleSubmit(handleUpdate)}>
        <label><span>First name</span><input autoComplete="given-name" type="text" {...register("firstName", { required: "Enter your first name." })} /></label>
        <label><span>Last name</span><input autoComplete="family-name" type="text" {...register("lastName", { required: "Enter your last name." })} /></label>
        <label><span>Email address</span><input type="email" value={details.email || ""} readOnly aria-readonly="true" /><small>Contact support to change your account email.</small></label>
        <label><span>Phone number</span><input type="tel" value={details.phone || ""} readOnly aria-readonly="true" /><small>Contact support to change your phone number.</small></label>
        <label><span>City</span><input autoComplete="address-level2" type="text" {...register("city")} /></label>
        <label><span>Country</span><input autoComplete="country-name" type="text" {...register("country")} /></label>
        <label><span>Gender</span><input type="text" {...register("gender")} /></label>
        <label><span>Date of birth</span><input type="text" placeholder="DD/MM/YYYY" {...register("dob")} /></label>
        <label><span>Marital status</span><input type="text" {...register("maritalStatus")} /></label>
        <label className="pg-address-field"><span>Address</span><input autoComplete="street-address" type="text" {...register("address")} /></label>
        <div className="pg-form-actions">
          <button type="button" className="pg-cancel-button" onClick={() => setTab(1)}>Cancel</button>
          <button className="pg-save-button" type="submit" disabled={loading} data-testid="button-save-profile">
            {loading ? <><FiLoader className="pg-loading-icon" size={15} /> Saving…</> : <><FiCheck size={15} /> Save updates</>}
          </button>
        </div>
      </form>
    </section>
  );
}

export default UpdateProfile;
